<!-- report_post_value.vue -->
<template>
  <div class="w-100" :id="id">
    <el-input
      v-if="open"
      :id="'input-' + id"
      min="0"
      :type="type == 'comment' ? 'textarea' : 'number'"
      :rows="type == 'comment' ? 4 : 1"
      inputmode="numeric"
      class="new-report-input"
      v-model="edit_value"
      @keydown.tab.native="editValue('tab')"
      @keypress.enter.exact.native="editValue('enter')"
      @keydown.esc.native="editValue('esc')"
      @change="!editing ? editValue() : ''"
      @blur="!editing ? editValue() : ''"
    ></el-input>
    <div v-else class="flex-row w-100">
      <div v-if="type == 'media_and_if'" class="flex-row w-100">
        <div class="new-report-media-profile pointer" @click="openInfluencer(value.account_name)">
          <div class="data-table-th-picture report pointer">
            <img :src="value.profile_picture_url" alt class="report-media-profile-img" @error="imgError()" />
            <favorite :favorite="value.favorite" :index="index" :referer="'report'" />
          </div>
          <div class="report-media-profile-namearea">
            <div class="report-media-profile-accountname">{{ value.account_name }}<img src="../../assets/badge.png" style="width: 14px; height: 14px" v-show="value.badge" /></div>
            <div class="report-media-profile-name">{{ value.name }}</div>
          </div>
        </div>
        <div class="flex-space"></div>
        <div style="position: relative" class="pointer">
          <el-image :src="value.post_url" class="new-report-media" @click="openMedia">
            <div slot="error" class="detail-img error new-report-media" @click="openMedia">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
            </div>
          </el-image>
          <div class="pr_type" v-show="value.pr_flag">
            <div class="pr_tag">PR</div> 
          </div>
          <div class="media_type report" v-show="value.media_type == 'GraphVideo' && (value.s3_url == 'feed' || value.s3_url == null)">
            <font-awesome-icon :icon="['far', 'play']" class="media_tag report" />
          </div>
          <div class="media_type report" v-show="value.media_type == 'GraphSidecar'">
            <font-awesome-icon :icon="['far', 'clone']" class="media_tag report" />
          </div>
          <el-tooltip content="通常の投稿よりも良いエンゲージメント率です。" placement="right">
          <div class="fine-egr" v-show="value.fine_egr">
            <font-awesome-icon :icon="['fas', 'check']"/>
          </div>
          </el-tooltip>
        </div>
      </div>
      <div
          v-else-if="type === 'caption'"
          class="new-report-caption-cell pointer"
          @click.stop.prevent="openMedia"
      >
        <pre class="new-report-caption-pre">{{ (value && value.caption) ? value.caption : "\u00A0" }}</pre>
      </div>
      <div v-else-if="type == 'number'">
        <span v-if="hasValue(value)">{{ value | addComma }}</span>
        <span v-else style="color:#aaa">
          <i v-if="editable" class="el-icon-edit"></i>
          <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color:#ccc"/>
        </span>
      </div>
      <div v-else-if="type == 'percent'">
        <span v-if="hasValue(value)">{{ value | formatPercent }}%</span>
        <span v-else><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </div>
      <div v-else-if="type == 'cost'">
        <span v-if="hasValue(value)">¥{{ value }}</span>
        <span v-else style="color:#aaa">
          <i v-if="editable" class="el-icon-edit"></i>
          <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color:#ccc"/>
        </span>
      </div>
      <div v-else-if="type == 'cost_setting'">
        <span v-if="hasValue(value)">¥{{ value | addComma }}</span>
        <span v-else style="color:#aaa">
          <i v-if="editable" class="el-icon-edit"></i>
          <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color:#ccc"/>
        </span>
      </div>
      <div v-else-if="type == 'comment'">
        <span v-if="hasValue(value)">{{ value }}</span>
        <span v-else style="color:#aaa"><i class="el-icon-edit"></i>コメントを入力できます</span>
      </div>
      <div v-else-if="type == 'refer'">
        <span v-if="hasValue(value)">{{ value | addComma }}</span>
        <span v-else><font-awesome-icon :icon="['far','hourglass-half']" style="color:#ccc"/></span>
      </div>
      <div v-else-if="type == 'refer_percent'">
        <span v-if="hasValue(value)">{{ value | formatPercent }}%</span>
        <span v-else><font-awesome-icon :icon="['far','hourglass-half']" style="color:#ccc"/></span>
      </div>
      <div v-else-if="type == 'gender'">
        <div class="data-table-th-gender">
          <genderRatio :female_ratio="value" :male_ratio="Math.round((100 - value) * 10)/10" />
        </div>
      </div>
      <div v-else-if="type == 'diff'">
        <span v-if="value && value > 0" style="color:#0a0" >+{{ value }}</span>
        <span v-else-if="value === 0" style="color:#666" >{{ value }}</span>
        <span v-else-if="value && value < 0" style="color:#a00" >{{ value }}</span>
        <span v-else style="color:#aaa"><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </div>
      <div v-else>
        <span v-if="hasValue(value)">{{ value }}</span>
      </div>
    </div>
    <div class="report-value-desc" v-show="column != 'caption'">
      <span v-show="!editable">編集不可</span>
    </div>
<!--    <div class="report-value-desc caption" v-show="column == 'caption'">-->
<!--      <font-awesome-icon :icon="['far', 'fa-arrow-up-right-and-arrow-down-left-from-center']" style="margin-right: 3px;" />-->
<!--      Enterで投稿を開く-->
<!--    </div>-->
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeReportPostAPI = root + "/api/report/change_report_post";

import favorite from "../list/favorite";
import genderRatio from "../list/gender_ratio";

export default {
  name: "reportPostValue",
  props: ["report_id", "media_id", "column", "index", "id", "value", "type", "editable", "sns_type"],
  components: {
    favorite,
    genderRatio
  },
  data() {
    return {
      open: false,
      editing: false,
      edit_value: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {},
  methods: {
    hasValue(v) {
      if (!this.editable) {
        const isNumericType = [
          "number", "percent", "cost", "cost_setting", "refer", "refer_percent"
        ].includes(this.type);
        if (isNumericType && (v === 0 || v === "0")) return false;
      }
      return v !== null && v !== undefined && v !== "";
    },
    openCell(value) {
      this.open = true;
      if (value && value.match(/[0-9]/)) {
        this.edit_value = value;
      } else if (value && value == "Backspace") {
        this.edit_value = "";
      } else {
        this.edit_value = this.value;
      }
      setTimeout(() => {
        document.getElementById("input-" + this.id).focus();
        this.addKeyDown();
        if (value == "Backspace") this.editValue("esc");
      }, 50);
    },
    editValue(presskey) {
      this.open = false;
      this.editing = true;
      if (this.value != this.edit_value) {
        this.$emit("syncValue", this.index, this.edit_value, this.column);
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("report_id", this.report_id);
        params.append("media_id", this.media_id);
        params.append("column", this.column);
        params.append("value", this.edit_value);
        params.append("sns_type", this.sns_type);
        this.axios
          .post(changeReportPostAPI, params)
          .then((response) => {
            this.$emit("updateValue", this.index, response.data.new_post_data);
          })
          .catch(() => {});
      }
      this.removeKeyDown();
      this.$emit("finishEdit", presskey);
      setTimeout(() => {
        this.editing = false; //keypressEnter/blur/changeが同時に発動しないように
      }, 300);
    },
    imgError() {
      this.value.profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    openMedia() {
      this.$emit("openMedia", this.index);
    },
    openInfluencer(account_name) {
      // this.$emit("openInfluencer", account_name);
      this.$emit("openInfluencer", account_name, this.sns_type);
    },
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    onKeyDown(event) {
      if (event.key == "ArrowUp") event.preventDefault();
      if (event.key == "ArrowDown") event.preventDefault();
    },
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
  watch: {},
  filters: {
    addComma(val) {
      if (val === "" || val === null || val === undefined) return "";
      if (isNaN(val)) return val;
      const n = Number(val);
      return Number.isInteger(n)
          ? n.toLocaleString()
          : n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    },
    formatPercent(val) {
      if (val === null || val === undefined || val === "" || isNaN(val)) return val;
      return Math.round(Number(val) * 100) / 100;
    },
  },
};
</script>
